import React from 'react'
import { Button, Grid, Icon, NotificationsStatusBar, Typography } from 'gu-ui-kit'
import styles from 'modules/Billing/Billing.module.scss'
import { ROUTES } from 'constants/routes'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

const Notification = () => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation(['billing'])
  const pathGen = useGeneratePathI18n()

  return (
    <NotificationsStatusBar
      className={styles['billing__info']}
      view={!breakpoints.md ? 's' : !breakpoints.lg ? 'm' : 'l'}
      color="static-Label-GU-Primary"
    >
      <Grid
        direction={'row'}
        wrap={false}
        gap={16}
        alignItems={'center'}
      >
        <Icon
          name="emoji-fire"
          width={44}
          height={44}
        />
        <Grid
          direction={'column'}
          gap={8}
        >
          <Typography
            variant={'Subtitle-30'}
            className={styles['billing__info-heading']}
          >
            {t('promised_payment')}
          </Typography>
          <Typography
            component={'span'}
            variant={'Body-20'}
            className={styles['billing__info-summary']}
          >
            {t('promised_payment_service')}
          </Typography>
          {!breakpoints.sm && (
            <div>
              <Button
                component="a"
                className={styles['billing__info-button']}
                variant="primary"
                bgColor={'Interface-Onsurface'}
                color={'Label-Primary'}
                target="_blank"
                href={pathGen(ROUTES.PROMISED_PAYMENT_TERMS)}
              >
                {t('learn_more')}
              </Button>
            </div>
          )}
        </Grid>
        {breakpoints.sm && (
          <Button
            component="a"
            className={styles['billing__info-button']}
            variant="primary"
            bgColor={'Interface-Onsurface'}
            color={'Label-Primary'}
            target="_blank"
            href={pathGen(ROUTES.PROMISED_PAYMENT_TERMS)}
          >
            {t('learn_more')}
          </Button>
        )}
      </Grid>
    </NotificationsStatusBar>
  )
}

export default Notification
